'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-900">
      <div className="text-center max-w-md">
        <h2 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4">문제가 발생했습니다</h2>
        <div className="mb-6">
          <img 
            src="/assets/error-image.png" 
            alt="Error illustration" 
            className="w-64 h-auto mx-auto mb-4"
          />
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            페이지를 표시하는 중에 오류가 발생했습니다. 문제가 지속되면 관리자에게 문의하세요.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => reset()}
            className="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            다시 시도
          </button>
          <Link 
            href="/"
            className="px-4 py-2 bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-200 font-medium rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            홈으로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
}